module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loggedIn()) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "top-menu"
  }, [_c('el-menu', {
    staticClass: "infc-menu",
    attrs: {
      "mode": "horizontal"
    },
    on: {
      "open": _vm.handleTopOpen
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": "/static/ckmlogo.png"
    }
  })]), _vm._v(" "), (_vm.loggedIn()) ? _c('el-menu-item', {
    staticClass: "infc-logout-button",
    attrs: {
      "index": "1"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log Out")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.loggedIn()) ? _c('div', {
    staticClass: "left-sub-menu"
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical",
    attrs: {
      "default-active": _vm.activeIndex,
      "theme": "dark",
      "router": true
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/"
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/surveillance"
    }
  }, [_vm._v("Infection Surveillance")]), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "Outbreak Management"
    }
  }), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "Infection Threshold"
    }
  }), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "Infection Analysis"
    }
  }), _vm._v(" "), _c('el-menu-item-group', {
    attrs: {
      "title": "Denominators"
    }
  }), _vm._v(" "), _c('el-submenu', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v("Setup")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/clients"
    }
  }, [_vm._v("Residents")])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('router-view')], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-670c6855!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/App.vue
// module id = 246
// module chunks = 2